var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { DateFieldSet as SavvyDateFieldSet } from "@savvyinsure/react-ui";
import dayjs from "dayjs";
import { useForm } from "react-hook-form";
export default function DateFieldSet(props) {
    var _a, _b, _c;
    var errorMessage = props.errorMessage, onChange = props.onChange, label = props.label, id = props.id;
    var parsedDefaultValues = (props.defaultValue || "").split("/");
    var defaultValues = {
        month: parsedDefaultValues[0],
        day: parsedDefaultValues[1],
        year: parsedDefaultValues[2],
    };
    var _d = useForm({
        mode: "onChange",
    }), register = _d.register, errors = _d.formState.errors, getValues = _d.getValues;
    var handleDateChange = function () {
        var values = getValues();
        var date = "".concat(values.month, "/").concat(values.day, "/").concat(values.year);
        if (onChange) {
            onChange(date);
        }
    };
    var monthInputProps = register("month", {
        required: "".concat(label, " must include a month"),
        validate: {
            isValid: function (value) {
                return dayjs(value, "MM", true).isValid() || "Please enter a valid month";
            },
        },
        setValueAs: function (value) { return value.padStart(2, "0"); },
        onChange: handleDateChange,
    });
    var dayInputProps = register("day", {
        required: "".concat(label, " must include a day"),
        validate: {
            isValid: function (value) {
                return dayjs(value, "DD", true).isValid() || "Please enter a valid day";
            },
        },
        setValueAs: function (value) { return value.padStart(2, "0"); },
        onChange: handleDateChange,
    });
    var yearInputProps = register("year", {
        required: "".concat(label, " must include a valid year (4 digits)"),
        validate: {
            isValid: function (value) {
                return dayjs(value, "YYYY", true).isValid() || "Please enter a valid year";
            },
        },
        onChange: handleDateChange,
    });
    var error = ((_a = errors === null || errors === void 0 ? void 0 : errors.month) === null || _a === void 0 ? void 0 : _a.message) ||
        ((_b = errors === null || errors === void 0 ? void 0 : errors.day) === null || _b === void 0 ? void 0 : _b.message) ||
        ((_c = errors === null || errors === void 0 ? void 0 : errors.year) === null || _c === void 0 ? void 0 : _c.message) ||
        errorMessage;
    return (React.createElement(React.Fragment, null,
        React.createElement("label", { className: "avvy-ui-mt-1 savvy-ui-text-xs savvy-ui-font-semibold savvy-ui-text-gray-100" }, label),
        React.createElement(SavvyDateFieldSet, { id: id, name: id, dayFieldProps: __assign(__assign({}, dayInputProps), { defaultValue: defaultValues.day, format: "##" }), monthFieldProps: __assign(__assign({}, monthInputProps), { defaultValue: defaultValues.month, format: "##" }), yearFieldProps: __assign(__assign({}, yearInputProps), { defaultValue: defaultValues.year, format: "####" }), errorMessage: error })));
}
